import { toString } from 'lodash';

export const serialize = (obj: unknown) => {
  return JSON.parse(JSON.stringify(obj));
};

export function jsonToFormData<T extends object>(
  data: T,
  formData: FormData = new FormData(),
  parentKey?: string
): FormData {
  for (const key in data) {
    // biome-ignore lint/suspicious/noPrototypeBuiltins: <explanation>
    if (data.hasOwnProperty(key)) {
      const value = data[key];
      const currentKey = parentKey ? `${parentKey}[${key}]` : key;

      if (value instanceof File) {
        formData.append(currentKey, value);
      } else if (Array.isArray(value)) {
        value.forEach((item) => {
          const arrayKey = `${currentKey}[]`;
          if (item instanceof File) {
            formData.append(arrayKey, item);
          } else {
            jsonToFormData({ [arrayKey]: item }, formData);
          }
        });
      } else if (typeof value === 'object' && value !== null) {
        jsonToFormData(value, formData, currentKey);
      } else {
        formData.append(currentKey, toString(value));
      }
    }
  }

  return formData;
}
